module.exports = __webpack_public_path__ + "img/Patient@2x.1fa50f4a.png";